import React from 'react'
import './_styles.scss'
import Utils from '../../../../../../../../../../../utils/Utils'
import Translator from '../../../../../../../../../../../requests/apa/Translator'
import { KEYSRESULT } from '../../../../../constants'
import store from '../../../../../../../../../../../store'
import { MODAL_MATCH_DETAIL, showModal } from '../../../../../../../../../../../actions/modal'

function Finalizado (props) {
  const homeTeam = props.homeTeam || {}
  const awayTeam = props.awayTeam || {}

  const openDetailMatch = (e) => {
    e.preventDefault()
    const { dateTime, id} = props

    const modalProps = {
      matchData: {
        matchId: id
      }
    }

    store.dispatch(showModal({
      modalType: MODAL_MATCH_DETAIL,
      modalProps
    }))
  }

  return (
    <a className='mc-fn match-card focusable' tabIndex={0} onClick={openDetailMatch}>
      <div className='mc-cd__band'>
        <div className='mc-cd__band mc-cd__band--home' style={{ background: homeTeam.color }} />
        <div className='mc-cd__band mc-cd__band--away' style={{ background: awayTeam.color }} />
      </div>

      <p className='mc-fn__title'>{Utils.cutPlayerString(Translator.get(`eventodeportivo_carruseletapas_ficha_texto_${props.status}`), 15)}</p>
      {props.result && (
        <span className={`mc-fn__badge mc-fn__badge--${props.result}`}>{Utils.cutPlayerString(Translator.get(KEYSRESULT[props.result]), 1, undefined, '')}</span>
      )}

      <p className='mc-fn__datetime'>{props.dateTime}</p>

      <p className='mc-fn__comp-name'>{props.competition}</p>
      <p className='mc-fn__comp-group'>{props.competitionGroup}</p>

      <div className='mc-fn__sep' />

      <div className='mc-fn__flag mc-fn__flag--home'>
        <img src={homeTeam.flagUrl} alt={homeTeam.name} />
      </div>
      <p className='mc-fn__team-name mc-fn__team-name--home'>{homeTeam.name}</p>
      <p className='mc-fn__score mc-fn__score--home'>{props.homeScore}</p>

      <div className='mc-fn__flag mc-fn__flag--away'>
        <img src={awayTeam.flagUrl} alt={awayTeam.name} />
      </div>
      <p className='mc-fn__team-name mc-fn__team-name--away'>{awayTeam.name}</p>
      <p className='mc-fn__score mc-fn__score--away'>{props.awayScore}</p>
    </a>
  )
}

export default Finalizado



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/CountryDetailsBody/Components/MatchCard/Components/Finalizado/index.jsx